import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/dist/photoswipe.css';
import { computed } from 'vue';

let lightbox = null;

const initPhotoSwipe = () => {
    if (!lightbox) {
        lightbox = new PhotoSwipeLightbox({
            gallery: '#pswp-gallery',
            children: 'a',
            pswpModule: () => import('photoswipe'),
            showHideAnimationType: 'zoom',
            padding:{top:0,bottom:0,left:0,right:0},
            viewportMaxWidth:computed(() => window.innerWidth < 768 ?  window.innerWidth * 0.98 : window.innerWidth * 0.8 ) ,
        });
        lightbox.init();
    }
};

const openPhotoSwipe = (images, startIndex = 0, width=null, height=null) => {
    console.log(images,startIndex)
    initPhotoSwipe();

    const dummyGallery = document.getElementById('pswp-gallery');
    dummyGallery.innerHTML = '';

    if (typeof images === 'string') {
        const link = document.createElement('a');
        link.href = images;
         link.target = '_blank';
        link.rel = 'noreferrer';
        dummyGallery.appendChild(link);
        
          const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                const height = 800
                const calculatedWidth = Math.round(height * aspectRatio);
                link.setAttribute('data-pswp-width', calculatedWidth);
                link.setAttribute('data-pswp-height',height);
                lightbox.loadAndOpen(0);
            };
            img.src = images;
           return
    }else if(Array.isArray(images)) {
        const promises = images.map((image) => {
            return new Promise((resolve) => {
                const link = document.createElement('a');
                link.href = image.url;
                link.target = '_blank';
                link.rel = 'noreferrer';

                 if(image.width && image.height){
                    link.setAttribute('data-pswp-width', image.width);
                    link.setAttribute('data-pswp-height', image.height);
                    dummyGallery.appendChild(link);
                    resolve();
                    return
                 }

                  const img = new Image();
                 img.onload = () => {
                    const aspectRatio = img.width / img.height;
                    const height = image.height || 800
                    const calculatedWidth = Math.round(height * aspectRatio);
                    link.setAttribute('data-pswp-width', calculatedWidth);
                    link.setAttribute('data-pswp-height',height);
                    dummyGallery.appendChild(link);
                    resolve();
                 };
                img.src = image.url;
            });
        });
        Promise.all(promises).then(() => {
            lightbox.loadAndOpen(startIndex);
        });
        return
    }
};

const destroyPhotoSwipe = () => {
    if (lightbox) {
        lightbox.destroy();
        lightbox = null;
    }
};

export default {
    install: (app) => {
        app.config.globalProperties.$openPhotoSwipe = openPhotoSwipe;
        app.provide('openPhotoSwipe', openPhotoSwipe);
        app.provide('destroyPhotoSwipe', destroyPhotoSwipe);
    }
};